import { S3_BUCKET_URL } from '@/constants';
import { useAccount } from '@/hooks/useAccount';
import { useLayoutSelections } from '@/pages/Onboarding/hooks/useLayoutSelections';
import { useManLayoutSelections } from '@/pages/Onboarding/hooks/useManLayoutSelections';

export const useConstructorBackgroundImage = () => {
  const { user } = useAccount();

  const {
    ageGeneration: womanAgeGeneration,
    bodyShape: womanBodyShape,
    hairColor: womanHairColor,
  } = useLayoutSelections();

  const {
    ageGeneration: manAgeGeneration,
    bodyShape: manBodyShape,
    ethnicity: manEthnicity,
  } = useManLayoutSelections();

  if (user?.onboarding_data.gender === 'male') {
    return `${S3_BUCKET_URL}/paywall/fast-pay-tab-man/${manAgeGeneration}/${manEthnicity}_${manBodyShape}.png`;
  } else {
    return `${S3_BUCKET_URL}/paywall/v6-sexy/women/${womanAgeGeneration}_${womanHairColor}_${womanBodyShape}.png`;
  }
};
